<template>
<div>
  <span id="square-brackets">[ <span id="role">{{  $t(`message.${role}`) }}</span> - <strong id="username">{{ username }}</strong> ]</span>
  &nbsp;
  <a href="#" @click="logout">{{ $t('message.logout') }}</a>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'PanelLogout',
  computed: mapGetters(['role', 'username']),
  methods: mapActions(['logout'])
}
</script>


<style scoped>
div {
  color: #000;
  outline: 0;
  vertical-align: baseline;
  font-style: normal;
  font-size: 100%;
  padding: 0;
  margin: 0;
  font-family: arial;
  text-align: left;
  border: 0px solid green;
  width: 70%;
  top: 10px;
  left: 0;
  position: absolute;
  white-space: nowrap;
}

#square-brackets {
  font-family: arial;
  text-align: left;
  outline: 0;
  vertical-align: baseline;
  font-style: normal;
  font-size: 12px;
  border: 0;
  padding: 0;
  margin: 0;
  color: #6da3bd;
}

#role {
  font-family: arial;
  text-align: left;
  outline: 0;
  vertical-align: baseline;
  font-style: normal;
  font-size: 12px;
  border: 0;
  padding: 0;
  margin: 0;
  color: #999;
}

#username {
  font-family: arial;
  text-align: left;
  color: #6da3bd;
  outline: 0;
  vertical-align: baseline;
  font-style: normal;
  font-size: 12px;
  border: 0;
  padding: 0;
  margin: 0;
  font-weight: bold;
}

a {
  font-family: arial;
  text-align: left;
  white-space: nowrap;
  text-decoration: underline;
  cursor: pointer;
  outline: 0;
  vertical-align: baseline;
  font-style: normal;
  font-size: 12px;
  border: 0;
  padding: 0;
  margin: 0;
  color: #999999;
}

a:hover {
  margin-right: 10px;
  color: #333333;
  padding: 0;
  border: 0;
  font-size: 12px;
  font-style: normal;
  vertical-align: baseline;
  outline: 0;
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
  text-align: left;
  font-family: arial;
}
</style>
